module.exports = __webpack_public_path__ + "media/images/audio-warning-icon-80d7a0fad003a2a1920c71c49e801759.svg";